import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../../../layouts/MainLayout';
import MeetingsDashboard from './dashboard';
import { Center, Loader } from '@/components/ui';

// Pages mounted additively. Lazy-loaded so the dashboard bundle stays lean.
const MeetingListPage = lazy(() => import('./list'));
const MeetingInvitationsPage = lazy(() => import('./invitations'));
const MyMeetingActionItemsPage = lazy(() => import('./my-action-items'));
const MeetingCalendarPage = lazy(() => import('./calendar'));
const MeetingCreatePage = lazy(() => import('./create'));
const BookVenuePage = lazy(() => import('./book-venue'));
const MeetingEditPage = lazy(() => import('./edit/[id]'));
const MeetingDetailPage = lazy(() => import('./view/[id]'));
// Administration
const AllMeetingsAdminPage = lazy(() => import('./admin/all-meetings'));
const VenueBookingsAdminPage = lazy(() => import('./admin/bookings'));
const VenuesAdminPage = lazy(() => import('./admin/venues'));
const MeetingReportsPage = lazy(() => import('./admin/reports'));
const MeetingLookupsPage = lazy(() => import('./admin/lookups'));
const MeetingSettingsPage = lazy(() => import('./admin/settings'));

/**
 * Meeting Management Routes
 * Routing configuration for Meetings domain with MainLayout
 */
export default function MeetingManagementRoutes() {
  return (
    <MainLayout domainKey="meetings">
      <Suspense
        fallback={
          <Center h={400}>
            <Loader size="lg" />
          </Center>
        }
      >
        <Routes>
          <Route path="/" element={<MeetingsDashboard />} />
          <Route path="list" element={<MeetingListPage />} />
          <Route path="my-meetings" element={<MeetingListPage />} />
          <Route path="invitations" element={<MeetingInvitationsPage />} />
          <Route path="my-action-items" element={<MyMeetingActionItemsPage />} />
          <Route path="calendar" element={<MeetingCalendarPage />} />
          <Route path="create" element={<MeetingCreatePage />} />
          <Route path="book-venue" element={<BookVenuePage />} />
          <Route path="edit/:id" element={<MeetingEditPage />} />
          <Route path="view/:id" element={<MeetingDetailPage />} />
          {/* Administration */}
          <Route path="admin/all-meetings" element={<AllMeetingsAdminPage />} />
          <Route path="admin/bookings" element={<VenueBookingsAdminPage />} />
          <Route path="admin/venues" element={<VenuesAdminPage />} />
          <Route path="admin/reports" element={<MeetingReportsPage />} />
          <Route path="admin/lookups/*" element={<MeetingLookupsPage />} />
          <Route path="admin/settings" element={<MeetingSettingsPage />} />
          <Route path="*" element={<Navigate to="/app/meetings" replace />} />
        </Routes>
      </Suspense>
    </MainLayout>
  );
}
